import {SOPostCertificate} from '../../core/certificate/so-post-certificate';
import {CertificateCore} from './certificate.core';
import {SOGetCertificate} from '../../core/certificate/so-get-certificate';
import {FormField, SelectionOption} from 'lionheartland';
import {postCertificateFormFieldOptions} from './post-certificate-form-fields';
import {AdapterProtocol} from 'lionheartland';
import {BasePost} from 'lionheartland';
import {UserCore} from '../user/user.core';
import {SOGetUser} from '../../core/user/so-get-user';

export class RAPostCertificate extends BasePost implements AdapterProtocol {
  formFieldOptions = Object.values(postCertificateFormFieldOptions);

  RequestClass = SOPostCertificate

  constructor(
    public entityCore: CertificateCore
  ) {
    super();
    if (postCertificateFormFieldOptions.user) {
      postCertificateFormFieldOptions.user.makeCore = true;
    }
  }

  onSet() {
    super.onSet()
  }

  prepareRequest() {
    this.request = new this.RequestClass(
      this.getFormValueFromIdentifier(
        'user',
        SOGetUser,
      ),
    )
  }


  onSelectionChange(field: FormField) {
    super.onSelectionChange(field)
  }

  fetchOptions(field: FormField) {
    super.fetchOptions(field)
  }

  getSelectionOption(field: FormField, entity): SelectionOption {
    return super.getSelectionOption(field, entity)
  }
}